module.exports = __webpack_public_path__ + "img/app-main.ca99ad2.png";